import { useEffect, useState } from "react";
import { Input, SpinnerIcon } from "@mercai/clever";

import { TextAreaSearchProps } from "./text-area-search.type";

export const TextAreaSearch = ({
  onChange,
  value,
  translations,
}: TextAreaSearchProps) => {
  const [localValue, setLocalValue] = useState(value);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (value !== localValue) setLocalValue(value);
  }, [value]);

  useEffect(() => {
    setIsLoading(true);
    
    const handler = setTimeout(() => {

      if (localValue === value) {
        setIsLoading(false);
        return;
      }

      onChange(localValue);

      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(handler);
  }, [localValue]);

  return (
    <Input
      placeholder={translations?.inputPlaceholder}
      value={localValue}
      onChange={setLocalValue}
      isTextArea
      iconRight={isLoading ? <SpinnerIcon /> : undefined}
    />
  );
};
